import React from 'react';
import {GameArticle, Image, ButtonUpdate, ButtonDelete} from "../layout/Interface";
import {useParams} from "react-router-dom";
import {Link} from "react-router-dom";
import firebase from "../../firebase";
import Swal from "sweetalert2";

const Game = ({game, setDelete}) => {
    const {id, console, imageUrl} = game;
    const {categorie} = useParams();

    const handleDelete = async () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Se borrará de la base de datos",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar'
          }).then(async (result) => {
            if (result.isConfirmed) {
                await firebase.db.collection(console).doc(id).delete()
                setDelete(true);

            }
        });
    }

    return (
        <GameArticle>
            <div className="flex-center">
                <Image src = {imageUrl} />
            </div>
            {/* <TitleGame>{name}</TitleGame> */}
            <div className="content-buttons">
                <ButtonUpdate>
                    <Link to = {`/${categorie}/${console}/${id}`} className = "link-game">Editar</Link>
                </ButtonUpdate>
                <ButtonDelete>
                    <p className = "link-game" onClick = {handleDelete}>Eliminar</p>
                </ButtonDelete>
            </div>
        </GameArticle>
    );
}
 
export default Game;